import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_SERVICE_ORDERS_REFRESH: createSagaAction('JOB_SITE_SERVICE_ORDERS_REFRESH'),

  JOB_SITE_SERVICE_ORDER_CREATE: createSagaAction('JOB_SITE_SERVICE_ORDER_CREATE'),
  JOB_SITE_SERVICE_ORDER_UPDATE: createSagaAction('JOB_SITE_SERVICE_ORDER_UPDATE'),
  JOB_SITE_SERVICE_ORDER_DELETE: createSagaAction('JOB_SITE_SERVICE_ORDER_DELETE'),

  GET_SERVICE_ORDER_ITEMS: createSagaAction('GET_SERVICE_ORDER_ITEMS'),
  MARK_TASK_COMPLETE: createSagaAction('MARK_TASK_COMPLETE'),

  QUICK_ADD_TASK: createSagaAction('QUICK_ADD_TASK')
}

// Action Creators
export const actions = {
  jobSiteServiceOrdersRefresh: ({ jobId, next }) => ({
    type: constants.JOB_SITE_SERVICE_ORDERS_REFRESH.ACTION,
    jobId,
    next
  }),

  createServiceOrder: ({ jobId, content, serviceOrderItems, userId }) => ({
    type: constants.JOB_SITE_SERVICE_ORDER_CREATE.ACTION,
    jobId,
    content,
    serviceOrderItems,
    userId
  }),

  updateServiceOrder: ({ jobId, serviceOrderId, userId, content, serviceOrderItems }) => ({
    type: constants.JOB_SITE_SERVICE_ORDER_UPDATE.ACTION,
    jobId,
    serviceOrderId,
    userId,
    content,
    serviceOrderItems
  }),

  deleteServiceOrder: ({ serviceOrderId, jobId }) => ({
    type: constants.JOB_SITE_SERVICE_ORDER_DELETE.ACTION,
    jobId,
    serviceOrderId
  }),

  getServiceOrderItems: serviceOrderId => ({
    type: constants.GET_SERVICE_ORDER_ITEMS.ACTION,
    serviceOrderId
  }),

  markTaskComplete: ({ jobId, taskId, serviceOrderId }) => ({
    type: constants.MARK_TASK_COMPLETE.ACTION,
    jobId,
    taskId,
    serviceOrderId
  }),

  quickAddTask: ({ task, userId }) => ({
    type: constants.QUICK_ADD_TASK.ACTION,
    task,
    userId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_SERVICE_ORDERS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_SERVICE_ORDERS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteServiceOrders: action.payload
      }
    case constants.GET_SERVICE_ORDER_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_SERVICE_ORDER_ITEMS.SUCCESS:
      return {
        ...state,
        jobSiteServiceOrdersItems: action.payload
      }
    case constants.JOB_SITE_SERVICE_ORDERS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_SERVICE_ORDER_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_SERVICE_ORDER_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_SERVICE_ORDER_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.QUICK_ADD_TASK.SUCCESS:
      return {
        ...state
      }
    case constants.MARK_TASK_COMPLETE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteServiceOrderActions.js